import { NavigationTab } from "~/types/types";

/**
 * Tab state.
 *
 * @export
 * @interface TabState
 */
export interface TabState {
    /**
     * Active tab.
     *
     * @type {NavigationTab}
     * @memberof TabState
     */
    active: NavigationTab;
}

/**
 * Initial tab module state.
 *
 * @return {(() => TabState)}
 */
const state = (): TabState => ({
    active: NavigationTab.Play,
});

export default state;
